import { X, Globe, Mail, Phone, Building2 } from "lucide-react";

const Row = ({ icon: Icon, href, children, testid }) => (
  <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" data-testid={testid}
    className="flex items-center gap-2 text-sm text-neutral-800 hover:underline break-all">
    <Icon className="h-4 w-4 shrink-0 text-neutral-500" /> {children}
  </a>
);

export const ServiceInfoModal = ({ profile: p, onClose, action }) => {
  const text = p.description || p.short_description;
  const site = p.website_url && (p.website_url.startsWith("http") ? p.website_url : `https://${p.website_url}`);
  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-white rounded-2xl border border-neutral-200 shadow-2xl w-full max-w-lg max-h-[90vh] overflow-y-auto text-left animate-in-up"
        onClick={(e) => e.stopPropagation()} data-testid={`service-info-modal-${p.key}`}>
        <div className="relative h-32 grid place-items-center border-b border-neutral-200 rounded-t-2xl" style={{ backgroundColor: p.logo_bg || "#fff" }}>
          {p.logo_url ? <img src={p.logo_url} alt={p.name} className="max-h-20 max-w-[70%] object-contain" />
            : <span className="font-display font-extrabold text-5xl text-neutral-300">{p.name.slice(0, 1)}</span>}
          <button onClick={onClose} className="absolute top-3 right-3 h-9 w-9 grid place-items-center rounded-full bg-[#E3FF00] text-neutral-900 hover:brightness-95" data-testid="service-info-close-button"><X className="h-4 w-4" /></button>
        </div>
        <div className="p-6 space-y-4">
          <div>
            <h3 className="font-display text-2xl font-extrabold text-neutral-900" data-testid="service-info-name">{p.name}</h3>
            {p.tagline && <p className="text-sm font-semibold uppercase tracking-wider text-neutral-500 mt-1" data-testid="service-info-tagline">{p.tagline}</p>}
            {p.title && <p className="text-neutral-900 font-medium mt-2">{p.title}</p>}
          </div>
          <p className="text-sm text-neutral-700 leading-relaxed whitespace-pre-line" data-testid="service-info-description">{text}</p>
          {(site || p.email || p.phone || p.legal_name) && (
            <div className="space-y-2 pt-3 border-t border-neutral-200">
              {p.legal_name && <div className="flex items-center gap-2 text-sm text-neutral-800"><Building2 className="h-4 w-4 text-neutral-500" /> {p.legal_name}</div>}
              {site && <Row icon={Globe} href={site} testid="service-info-website">{p.website_url}</Row>}
              {p.email && <Row icon={Mail} href={`mailto:${p.email}`} testid="service-info-email">{p.email}</Row>}
              {p.phone && <Row icon={Phone} href={`tel:${p.phone}`} testid="service-info-phone">{p.phone}</Row>}
            </div>
          )}
          {action}
        </div>
      </div>
    </div>
  );
};
